import { render, staticRenderFns } from "./LmCustomBuilderUi.vue?vue&type=template&id=fa948566&"
import script from "./LmCustomBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmCustomBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports